module.exports = __webpack_public_path__ + "img/kucoin.4cbddacc.png";